import { useSearchParams } from "react-router-dom";
import { usePhotos } from "@/lib/usePhotos";
import { Gallery } from "@/components/site/Gallery";

const DEFAULT_THEME = "weddings";

export default function GalleryPage() {
  const { themes, photos } = usePhotos();
  const [params, setParams] = useSearchParams();
  const requested = params.get("theme");
  const theme = themes.some((t) => t.id === requested) ? requested : DEFAULT_THEME;
  const setTheme = (id) => {
    const next = new URLSearchParams(params);
    next.set("theme", id);
    setParams(next);
  };
  return (
    <main id="top" className="gallery-page" data-testid="gallery-page">
      <Gallery themes={themes} photos={photos} filter={theme} setFilter={setTheme} />
    </main>
  );
}
